"use strict"; // Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _slicedToArray = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkDialog = void 0;

var clsx_1 = __importDefault(require("clsx"));

var preact_1 = require("preact");

var hooks_1 = require("preact/hooks");

var LinkDialog_css_1 = __importDefault(require("./LinkDialog-css"));

var QRCode_1 = require("./QRCode");

var Spinner_1 = require("./Spinner");

exports.LinkDialog = function (props) {
  var _hooks_1$useState = hooks_1.useState(!props.isOpen),
      _hooks_1$useState2 = _slicedToArray(_hooks_1$useState, 2),
      isContainerHidden = _hooks_1$useState2[0],
      setContainerHidden = _hooks_1$useState2[1];

  var _hooks_1$useState3 = hooks_1.useState(!props.isOpen),
      _hooks_1$useState4 = _slicedToArray(_hooks_1$useState3, 2),
      isDialogHidden = _hooks_1$useState4[0],
      setDialogHidden = _hooks_1$useState4[1];

  hooks_1.useEffect(function () {
    var isOpen = props.isOpen;
    var timers = [window.setTimeout(function () {
      setDialogHidden(!isOpen);
    }, 10)];

    if (isOpen) {
      setContainerHidden(false);
    } else {
      timers.push(window.setTimeout(function () {
        setContainerHidden(true);
      }, 360));
    }

    return function () {
      timers.forEach(window.clearTimeout);
    };
  }, [props.isOpen]);
  return preact_1.h("div", {
    class: clsx_1.default("-walletlink-link-dialog-container", props.darkMode && "-walletlink-link-dialog-container-dark", isContainerHidden && "-walletlink-link-dialog-container-hidden")
  }, preact_1.h("style", null, LinkDialog_css_1.default), preact_1.h("div", {
    class: clsx_1.default("-walletlink-link-dialog-backdrop", isDialogHidden && "-walletlink-link-dialog-backdrop-hidden")
  }), preact_1.h("div", {
    class: "-walletlink-link-dialog"
  }, preact_1.h("div", {
    class: clsx_1.default("-walletlink-link-dialog-box", isDialogHidden && "-walletlink-link-dialog-box-hidden")
  }, preact_1.h(ScanQRCode, {
    darkMode: props.darkMode,
    version: props.version,
    sessionId: props.sessionId,
    sessionSecret: props.sessionSecret,
    walletLinkUrl: props.walletLinkUrl,
    isConnected: props.isConnected
  }), props.onCancel && preact_1.h(CancelButton, {
    onClick: props.onCancel
  }))));
};

var ScanQRCode = function ScanQRCode(props) {
  var serverUrl = window.encodeURIComponent(props.walletLinkUrl);
  var qrUrl = "".concat(props.walletLinkUrl, "/#/link?id=").concat(props.sessionId, "&secret=").concat(props.sessionSecret, "&server=").concat(serverUrl, "&v=1");
  return preact_1.h("div", {
    class: "-walletlink-link-dialog-box-content"
  }, preact_1.h("h3", null, "Scan to", preact_1.h("br", null), " Connect"), preact_1.h("div", {
    class: "-walletlink-link-dialog-box-content-qrcode"
  }, preact_1.h("div", {
    class: "-walletlink-link-dialog-box-content-qrcode-wrapper"
  }, preact_1.h(QRCode_1.QRCode, {
    content: qrUrl,
    width: 224,
    height: 224,
    fgColor: "#000",
    bgColor: "transparent"
  })), preact_1.h("input", {
    type: "hidden",
    value: qrUrl
  }), !props.isConnected && preact_1.h("div", {
    class: "-walletlink-link-dialog-box-content-qrcode-connecting"
  }, preact_1.h(Spinner_1.Spinner, {
    size: 128,
    color: props.darkMode ? "#fff" : "#000"
  }), preact_1.h("p", null, "Connecting...")), preact_1.h("p", {
    title: "WalletLink v".concat(props.version)
  }, "Powered by WalletLink")), preact_1.h("a", {
    href: "".concat(props.walletLinkUrl, "/#/wallets"),
    target: "_blank",
    rel: "noopener"
  }, "Don\u2019t have a wallet app?"));
};

var CancelButton = function CancelButton(props) {
  return preact_1.h("button", {
    class: "-walletlink-link-dialog-box-cancel",
    onClick: props.onClick
  }, preact_1.h("div", {
    class: "-walletlink-link-dialog-box-cancel-x"
  }));
};